import { MONOLITH_HOST } from '@constants/routes';
import { MagicSearchResults } from '@domain/magic-search';
import { useGenericQuery } from '@hooks/use-generic-query';
import { keepPreviousData } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from '../constants.type';

import { MAGIC_SEARCH_LIMIT } from './constants';
import type { UseGetMagicSearchParams } from './use-get-magic-search.type';

const getMagicSearch = (term: string): Promise<MagicSearchResults> => {
  const params = new URLSearchParams({ q: term, limit: String(MAGIC_SEARCH_LIMIT) });
  return request({ url: `${MONOLITH_HOST}/v1/admin/search?${params.toString()}`, method: RequestMethod.GET });
};

export const useGetMagicSearch = ({ term, enabled = true }: UseGetMagicSearchParams) =>
  useGenericQuery<MagicSearchResults, RequestError>([QUERY_KEYS.getMagicSearch, term], () => getMagicSearch(term), {
    enabled: enabled && term !== '',
    // The previous results stay on screen while the next term loads, instead of the list collapsing on every keystroke.
    placeholderData: keepPreviousData,
    // The palette shows the failure in its list; the generic toast would sit behind the dialog.
    hideError: true,
  });
